import { render, staticRenderFns } from "./print-footer.vue?vue&type=template&id=9da08056&scoped=true"
import script from "./print-footer.vue?vue&type=script&lang=js"
export * from "./print-footer.vue?vue&type=script&lang=js"
import style0 from "./print-footer.vue?vue&type=style&index=0&id=9da08056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da08056",
  null
  
)

export default component.exports